export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5477.024b38df.jpg";